import React, { useEffect, useState } from 'react';
import './CpaSubmitButton.scss';
import { Button } from '@thd-olt-component-react/button';
import { Loader } from '@thd-olt-component-react/loader';
import PropTypes from 'prop-types';

const CpaSubmitButton = (props) => {

  const { isSubmitEnabled, isSubmitError, onClick } = props;

  const [isSubmitSpinning, setSubmitSpinning] = useState(false);

  useEffect(() => {
    if (isSubmitError) {
      setSubmitSpinning(false);
    }
  });
  const handleClick = () => {
    onClick();
    setSubmitSpinning(true);
  };
  return (
    <Button type="submit" disabled={!isSubmitEnabled || isSubmitSpinning} onClick={handleClick}>
      {isSubmitSpinning ? (
        <div>
          <Loader active bttn />
          <span className="cpa-submit__button">Submitting...</span>
        </div>
      )
        : 'Submit' }
    </Button>
  );
};

CpaSubmitButton.defaultProps = {
  isSubmitEnabled: false,
  isSubmitError: false,
  onClick: () => {
    null;
  }
};

CpaSubmitButton.propTypes = {
  isSubmitEnabled: PropTypes.bool,
  isSubmitError: PropTypes.bool,
  onClick: PropTypes.func
};

CpaSubmitButton.displayName = 'CpaSubmitButton';

export { CpaSubmitButton };
